import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../redux-slice/user.slice";
import epaperReducer from "../redux-slice/epaper.slice";
import staffReducer from "../redux-slice/staff.slice";
import roleReducer from "../redux-slice/role.slice";
import customizationReducer from "store/customizationReducer";

export const store = configureStore({
  reducer: {
    user: userReducer,
    epaper: epaperReducer,
    staff: staffReducer,
    roles: roleReducer,
    customization: customizationReducer,
  },
});
